<template>
	<div v-if="visible" class="drawer background darken-1">
		<BabelCardView
			:card="card"
			:is_child="true"
			@close="$emit('close')"></BabelCardView>
	</div>
</template>

<script>
import BabelCardView from '@/components/babel_card_view.vue'
export default {
	components: {
		BabelCardView
	},
	props: [
		'visible',
		'card'
	],
	methods: {
		close (visible) {
			if (!visible) this.$emit('close')
		}
	}
}
</script>

<style lang="stylus" scoped>
.drawer
    position: absolute;
    right: 0;
    top: 88px;
    min-width: 50%;
    max-width: 50%;
    height: calc(100% - 88px);
    overflow-y: auto;
</style>



// WEBPACK FOOTER //
// src/components/babel_card_right_drawer.vue